import tmhRequest from '@/config/tmhRequest'

export default {

    searchListServiceClassify: function (data) {
        return tmhRequest({
            url: '/project/serviceclassify/searchlistserviceclassify',
            method: 'post',
            params: data,
        })
    },

    searchServiceClassifyTree: function (data) {
        return tmhRequest({
            url: '/project/serviceclassify/searchserviceclassifytree',
            method: 'post',
            params: data,
        })
    },

    addServiceClassify: function (data) {
        return tmhRequest({
            url: '/project/serviceclassify/addserviceclassify',
            method: 'post',
            params: data,
        })
    },

    editServiceClassify: function (data) {
        return tmhRequest({
            url: '/project/serviceclassify/editserviceclassify',
            method: 'post',
            params: data,
        })
    },

    
    deleteServiceClassify: function (data) {
        return tmhRequest({
            url: '/project/serviceclassify/deleteserviceclassify',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/item/serviceclassify.js